import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {
  EsriAreaMeasurement2D,
  EsriDistanceMeasurement2D,
  EsriExpand,
  EsriReactiveUtils
} from '../../../config/esri.module';
import { MainMapService } from '../../../shared/service/main-map.service';
import { WidgetNotifyService } from '../../../shared/service/widget-notify.service';
import { BaseWidget } from '../base-widget/base-widget';

@Component({
    selector: 'measure',
    templateUrl: './measure.component.html',
    styleUrls: ['measure.component.scss'],
    standalone: false
})
export class MeasureComponent extends BaseWidget implements OnInit, OnDestroy {
  @ViewChild('measureComponentRef', { static: true }) measureComponentRef: ElementRef;
  @ViewChild('draggable', { static: true }) draggable: ElementRef;
  @ViewChild('dragArea', { static: true }) dragArea: ElementRef;

  public widgetToolTip: string;
  public measurements: Array<__esri.DistanceMeasurement2D | __esri.AreaMeasurement2D> = [];

  constructor(
    public mainMapService: MainMapService,
    public widgetNotifyService: WidgetNotifyService,
    private translate: TranslateService
  ) {
    super(mainMapService, widgetNotifyService);
  }

  ngOnInit() {
    const mapView = this.mainMapService.mapView;
    this.translateWidget();
    this.handleExpandWidget(mapView);
  }

  public createDistanceMeasure() {
    this.measurements.push(new EsriDistanceMeasurement2D());
  }

  public createAreaMeasure() {
    this.measurements.push(new EsriAreaMeasurement2D());
  }

  private handleExpandWidget(mapView: __esri.MapView) {
    this.expandWidget = new EsriExpand(this.expandInstanceProperties(mapView));
    this.mainMapService.registerWidget(this.expandWidget);
    // add widget to the main map
    mapView.ui.add(this.expandWidget, 'top-right');
    // Open this widget, will close other widgets
    EsriReactiveUtils.watch(
      () => this.expandWidget.expanded,
      () => {
        if (this.expandWidget.expanded) {
          this.mainMapService.deactivateMapInteraction();
          this.mainMapService.closeOtherWidgets(this.expandWidget);
        } else {
          if (this.isMeasureToolActive()) {
            this.expandWidget.expand();
            return;
          }
          this.mainMapService.activateMapInteraction();
        }
      }
    );

    // expand widget on create
    if (this.expandOnInit) {
      this.expandWidget.expand();
    }
  }

  private expandInstanceProperties(mapView: __esri.MapView): __esri.ExpandProperties {
    return {
      view: mapView,
      id: 'MeasureComponent',
      content: this.measureComponentRef.nativeElement,
      expandIcon: 'nodes-link',
      collapseTooltip: this.widgetToolTip,
      expandTooltip: this.widgetToolTip,
    };
  }

  private isMeasureToolActive(): boolean {
    const measureIsActive = false;
    const activeMeasureTool = this.measurements.find(f => f['active'] === true);
    if (activeMeasureTool) return true;
    return measureIsActive;
  }

  /**
   * @function destroyWidget
   * @description Destroy the Esri Expand Widget of this component
   */
  public destroyWidget() {
    this.destroySelf();
    this.mainMapService.activateMapInteraction();
  }

  /**
   * @description gets called whenwidget gets destroyed.
   * resets the cursor to standard mousecursor.
   */
  ngOnDestroy(): void {}

  private translateWidget() {
    this.translate.get('WIDGET.MEASURE.TOOLTIP').subscribe(msg => {
      this.widgetToolTip = msg;
    });
  }
}
